import React from 'react';

interface BarGraphProps {
  showValueLabel?: boolean;
  currentValue?: number;
  totalValue?: number;
  color?: string;
  status?: string;
}

const BarGraph: React.FC<BarGraphProps> = ({
  showValueLabel = false,
  currentValue = 100,
  totalValue = 100,
  color = 'var(--full-bar-color)',
  status,
}) => {
  return (
    <div
      style={{
        width: '100%',
        alignItems: 'center',
      }}
    >
      {showValueLabel && (
        <div
          style={{
            fontSize: '16px',
            fontWeight: 600,
            color: 'var(--secondary-text-color)',
            width: '10%',
            verticalAlign: 'middle',
            marginRight: 20,
            display: 'inline-grid',
            textAlign: 'center',
          }}
        >
          {currentValue}
        </div>
      )}
      <div
        style={{
          width: '60%',
          height: 16,
          background: 'var(--background-bar-color)',
          borderRadius: 999,
          overflow: 'hidden',
          display: 'inline-grid',
          verticalAlign: 'middle',
        }}
      >
        <div
          style={{
            width: `${(currentValue / totalValue) * 100}%`,
            height: '100%',
            background: color,
          }}
        />
      </div>
      {status && (
        <div
          className={
            status === 'Good'
              ? 'screening-badge chip-green'
              : status === 'Medium'
              ? 'screening-badge chip-yellow'
              : 'screening-badge chip-red'
          }
          style={{
            width: 'fit-content',
            display: 'inline-block',
            marginLeft: '15px',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          {status}
        </div>
      )}
    </div>
  );
};

export default BarGraph;
